export const webEmbedTab = {
  scope: {
    title: "O que o seu site deve buscar?",
    only: "Apenas",
    thisListing: "este anúncio",
    hint: "Recomendado se você colar o código na página desta acomodação. Desative para que a busca mostre todas as suas acomodações.",
  },
  where: {
    title: "Onde as acomodações devem aparecer?",
    hint: 'A barra de busca fica igual nos três casos. O que muda é o que acontece quando o visitante toca em "Buscar".',
    ariaLabel: "Onde a disponibilidade aparece",
    ownFields: {
      name: "Já tenho minha própria barra de busca",
      hint: "Não adicionaremos nossa barra: use seus próprios campos e nos entregue a busca",
    },
  },
  modes: {
    overlay: {
      name: "Flutuando sobre o seu site",
      tag: "Recomendado",
      desc: "A lista abre em uma janela sobre a sua página e fecha com o X. Seu site não se move: o visitante volta exatamente para onde estava.",
    },
    inline: {
      name: "Dentro da sua página",
      desc: "A lista aparece no seu próprio site, como mais uma seção: ela rola junto com o restante do conteúdo e não há nada para fechar. Você escolhe onde na página ela aparece.",
    },
    tab: {
      name: "Em uma nova aba",
      desc: "A barra fica no seu site e, ao buscar, a reserva continua em outra aba. É a opção mais simples, mas o visitante leva a reserva para outro lugar.",
    },
  },
  modeNote: {
    overlay: "A barra de busca mantém uma altura fixa e não muda: a lista e todo o processo de reserva acontecem na janela flutuante, com sua própria rolagem.",
    inline: "Aqui a única coisa que cresce é a seção da lista, que é exatamente o que você pediu para crescer. A barra de busca continua ocupando o mesmo espaço e o calendário abre acima dela, sem deslocar nada.",
    tab: "Apenas a barra fica incorporada. Todo o restante acontece no motor de reservas, em uma aba separada.",
  },
  webs: {
    bahia: "Site com um hero",
    cala: "Site minimalista",
  },
  fondos: {
    white: "Branco (padrão)",
    transparent: "Transparente · adota o do seu site",
  },
  appearance: {
    title: "Aparência",
    buttonColor: "Cor do botão",
    background: "Fundo da barra de busca",
    language: "Idioma",
  },
  preview: {
    title: "Como fica em um site",
    hint: "Um site de exemplo com sua barra de busca no lugar. É o widget real: escolha as datas e toque em Buscar para ver como ele se comporta.",
    openFull: "Abrir em tamanho real",
    testIn: "Testar em",
    testInAriaLabel: "Site de exemplo",
    missingUuid: "Falta o identificador da conta para gerar o widget.",
    fakeUrl: "seu-site.com",
    iframeTitle: "Prévia do widget em um site de exemplo",
  },
  guide: {
    title: "Como adicioná-lo ao seu site",
    hint: 'Funciona em qualquer página: HTML, WordPress (bloco "HTML personalizado"), Wix, Squarespace, Shopify… Nada para instalar.',
    warn: "<b>Se o seu site for Wix, Squarespace ou Shopify</b>, duas coisas: no <b>editor</b> o bloco de código sempre parece vazio —ele só funciona em \"Prévia\" ou depois de publicado—, e como essas plataformas envolvem a barra de busca em uma caixa própria, <b>tudo acontece dentro dessa caixa</b>: o calendário e a lista de acomodações. Por isso, <b>estenda-a para cerca de 900 px de altura</b> no editor; se ficar muito curta, o calendário fica cortado. Cuidamos do resto: não altere o código.",
    missingUuid: "Falta o identificador da conta para gerar o código.",
    copy: "Copiar",
    copied: "Copiado",
    saveReload: "Salve e recarregue o seu site",
  },
  steps: {
    script: {
      title: "Cole isto onde você quer que a barra de busca apareça",
      titleOwn: "Cole isto uma vez, em qualquer lugar da página",
      hint: "Bem onde você quer a barra de datas: o hero, uma faixa abaixo do menu, uma barra lateral…",
      hintOwn: "Ele não desenha nada sozinho: deixa a reserva pronta para o seu próprio formulário.",
      after: "A barra mantém uma altura fixa e não será redimensionada, então não vai atrapalhar o seu layout.",
    },
    target: {
      title: "Cole este espaço onde você quer que a lista apareça",
      hint: 'Geralmente uma seção própria abaixo do hero, com seu título acima dela ("Disponibilidade", "Nossas casas"…).',
      after: "Até que alguém faça uma busca, esse espaço não ocupa lugar nenhum. Se você deixá-lo de fora, a lista aparece logo abaixo da barra de busca.",
    },
    api: {
      title: "Conecte seus campos à busca",
      hint: "Você mantém seu design, mas o calendário pode ser o nosso: aquele que mostra o preço de cada noite, a estadia mínima e os dias reservados.",
      after: "Se preferir seus próprios campos de data, também funciona: passe-nos as datas no formato YYYY-MM-DD direto para WACheckin.search().",
    },
  },
  toasts: {
    manualCopySummary: "Cópia manual",
    manualCopyDetail: "Seu navegador não permitiu a cópia automática. O código já está selecionado.",
  },
};
